import type { ProcessStep, Service, Stat } from '@/types'

export const marqueeItems: string[] = [
    "Web design",
    "Art direction",
    "Front-end development",
    "Brand identity",
    "Motion & interaction",
    "Design systems"
]

export const services: Service[] = [
    {
        title: "Web design",
        description: "Art-directed websites that look like nobody else's, from the first moodboard to pixel-perfect layouts for every screen size.",
        deliverables: ["Art direction", "UX/UI design", "Prototypes"]
    },
    {
        title: "Development",
        description: "Hand-built, fast and accessible sites in Next.js or Webflow, set up so your team can update them without calling me.",
        deliverables: ["Next.js", "Webflow", "CMS setup"]
    },
    {
        title: "Brand identity",
        description: "Logos, type systems and color palettes designed to work hardest on screens, where your customers actually meet you.",
        deliverables: ["Logo", "Typography", "Guidelines"]
    },
    {
        title: "Motion & interaction",
        description: "Micro-interactions and scroll stories that reward curiosity and make people linger a little longer than they planned to.",
        deliverables: ["Interaction design", "Animation", "Scroll stories"]
    },
    {
        title: "Design partnership",
        description: "Ongoing monthly support for teams that ship often: campaign pages, new features and care for your design system.",
        deliverables: ["Retainers", "Landing pages", "Design systems"]
    }
]

export const processSteps: ProcessStep[] = [
    {
        title: "Discover",
        timing: "Week 1",
        description: "We start with a workshop about your goals, your audience and what success looks like. I dig into your analytics, competitors and brand until the brief is crystal clear."
    },
    {
        title: "Direction",
        timing: "Week 2",
        description: "You get two distinct creative directions with moodboards, type and color, so you can react to something real instead of trying to imagine it."
    },
    {
        title: "Design",
        timing: "Weeks 3–6",
        description: "Full designs and clickable prototypes for desktop and mobile, refined together in short, focused feedback rounds. No endless revisions, no surprises."
    },
    {
        title: "Build & launch",
        timing: "Weeks 6–10",
        description: "I develop, test and launch the site, then hand it over with a content editor you will actually enjoy using and a walkthrough video for your team."
    }
]

export const aboutStats: Stat[] = [
    { value: "9+", label: "years designing for the web" },
    { value: "80+", label: "websites launched" },
    { value: "14", label: "countries with happy clients" }
]

export const projectTypes: string[] = [
    "Website",
    "Landing page",
    "Brand + website",
    "Redesign",
    "Something else"
]

export const budgets: string[] = [
    "Under €5k",
    "€5k–10k",
    "€10k–25k",
    "€25k+",
    "Not sure yet"
]
